/**
 * Helpers for the Meeting Prep send-time picker. The API stores `sendHourLocal` as a whole hour
 * (0–23) in the user's local timezone, so the picker only offers on-the-hour options.
 */

export const DEFAULT_SEND_HOUR = 7;

export interface SendHourOption {
	value: number;
	label: string;
}

/** Format a 0–23 hour as a 12-hour clock label, e.g. 0 → "12:00 AM", 7 → "7:00 AM", 13 → "1:00 PM". */
export function formatHourLabel(hour: number): string {
	const normalized = ((hour % 24) + 24) % 24;
	const period = normalized < 12 ? 'AM' : 'PM';
	const hour12 = normalized % 12 === 0 ? 12 : normalized % 12;
	return `${hour12}:00 ${period}`;
}

/** All 24 whole-hour options for the send-time picker, midnight → 11 PM. */
export function getSendHourOptions(): SendHourOption[] {
	return Array.from({ length: 24 }, (_, hour) => ({ value: hour, label: formatHourLabel(hour) }));
}
